module.exports = __webpack_public_path__ + "svg/scroll-down.svg";